import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, serverTimestamp } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
     apiKey: "AIzaSyAgH-Jjekl8UnCIsDZdxZEOvn73ahHGviM",
    authDomain: "wiazary-system.firebaseapp.com",
    projectId: "wiazary-system",
    storageBucket: "wiazary-system.appspot.com",
    messagingSenderId: "137692401767",
    appId: "1:137692401767:web:ed2417a8617c74affc04c2"
  };

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Initialize Firebase services (modular)
const projectAuth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);

// Timestamp utility (modular) — export the function itself, call it when writing to Firestore
const timestamp = serverTimestamp;

// Export all
export { projectAuth, db, storage, functions, timestamp };

//for import import { db, storage, functions, projectAuth, timestamp } from '@/firebase/config';
